/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-indent */
/* eslint-disable no-nested-ternary */
import * as React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import TextField from '@mui/material/TextField';
import Avatar from '@mui/material/Avatar';
import Autocomplete from '@mui/material/Autocomplete';
import InputAdornment from '@mui/material/InputAdornment';

import { blueGrey } from '@mui/material/colors';
import {
  Button,
  Paper,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Horse from '../../Horse';
import HorseIcon from '../../CustomIcons/Horse';

// Custom PaperComponent to include a footer
const CustomPaper = (props) => {
  const {
    children,
    ...other
  } = props;
  const navigate = useNavigate();
  const selectedLocation = useSelector((state) => state.location.selectedLocation);
  return (
    <Paper {...other}>
      {children}
      <div
        style={{
          padding: '8px',
          borderTop: '1px solid #eee',
          display: 'block',
          width: '100%',
        }}
      >
        <Button
          size="small"
          sx={{ width: '100%' }}
          onClick={() => { navigate('/horses') }}
          onMouseDown={(event) => event.preventDefault()} // Prevent blur
        >
          Manage All Horses
        </Button>
        {selectedLocation && selectedLocation.id && (
          <Button
            size="small"
            color="secondary"
            sx={{ width: '100%' }}
            onClick={() => { navigate(`/settings/locations?locationId=${selectedLocation.id}`) }}
            onMouseDown={(event) => event.preventDefault()} // Prevent blur
          >
            Manage Horses at {selectedLocation.name}
          </Button>
        )}
      </div>
    </Paper>
  );
};

const BarnHorsesAutocomplete = ({
  onSelect,
  value,
  validation,
  multiple,
  size,
  limitTags,
  barnHorses,
  disabled,
  label,
  helperText,
  blurOnSelect,
  showAdornment,
  disableCloseOnSelect,
}) => {
  // React state
  const [search, setSearch] = React.useState('');

  // Redux state
  const allBarnHorses = useSelector((state) => state.barn.allBarnHorses);
  const permissions = useSelector((state) => state.user.permissions);

  const getPicture = (horse) => `https://${horse.picture
    ? `${horse.picture}?cacheBust=${new Date()}`
    : `i0.wp.com/cdn.auth0.com/avatars/${horse.name.charAt(0).toLowerCase()}.png`}`;

  const barnHorseOptions = barnHorses || allBarnHorses;

  return (
    <Autocomplete
      id="barn-horses-select-autocomplete"
      disabled={disabled}
      blurOnSelect={blurOnSelect || !multiple}
      multiple={multiple}
      onChange={(e, v) => { setSearch(''); onSelect(e, v); e.currentTarget.blur() }}
      disableCloseOnSelect={multiple || disableCloseOnSelect}
      size={size}
      disableClearable
      sx={{ width: '100%' }}
      limitTags={limitTags}
      options={[...barnHorseOptions].filter((bh) => bh.horse.name.toLowerCase().indexOf(search.toLowerCase()) >= 0)
        .sort((a, b) => -b.horse.name.localeCompare(a.horse.name))}
      value={value}
      isOptionEqualToValue={(option, valueCompare) => option.id === valueCompare.id}
      getOptionLabel={(option) => (option.horse && option.horse.name) || ''}
      renderOption={(props, option, { selected }) => (
        <li
          {...props}
          style={{
            paddingLeft: '4px',
            backgroundColor: selected
              ? blueGrey[100]
              : 'inherit',
          }}
          key={`barn-horse-autocomplete-option-${option.id}`}
        >

          <Horse
            size={28}
            key={`barn-horse-autocomplete-option-${option.id}`}
            horse={option.horse}
          />
        </li>
      )}
      renderTags={(tagValue, getTagProps) => tagValue.map((option, index) => (
        <Horse
          size={18}
          key={`barn-horse-autocomplete-${option.id}`}
          chip
          {...getTagProps({ index })}
          horse={option.horse}
        />
      ))}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label || `Horse${multiple
            ? 's'
            : ''}`}
          fullWidth
          onChange={(e) => { setSearch(e.target.value); }}
          error={!!validation}
          helperText={(validation && validation) || helperText}
          InputProps={multiple
            ? (showAdornment
              ? {
                ...params.InputProps,
                startAdornment: (
                  <>
                    <InputAdornment position="start">
                      <HorseIcon />
                    </InputAdornment>
                    {params.InputProps.startAdornment}
                  </>
                ),
              }
              : { ...params.InputProps }
            )
            : {
              ...params.InputProps,
              startAdornment: (value && !Array.isArray(value))
                ? (
                  <InputAdornment position="start">
                    <Avatar
                      sx={{
                        width: 24,
                        height: 24,
                      }}
                      alt={value.horse.name}
                      src={getPicture(value.horse)}
                    />
                  </InputAdornment>
                )
                : null,
              // eslint-disable-next-line indent
            }}
        />
      )}
      slots={{
        paper: (barnHorses && (permissions.admin || permissions.owner))
          ? CustomPaper
          : undefined,
      }} // Assign your custom PaperComponent

    />
  );
};

BarnHorsesAutocomplete.propTypes = {
  onSelect: PropTypes.func.isRequired,
  value: PropTypes.any,
  validation: PropTypes.any,
  multiple: PropTypes.bool,
  size: PropTypes.string,
  limitTags: PropTypes.number,
  barnHorses: PropTypes.array,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  helperText: PropTypes.string,
  blurOnSelect: PropTypes.bool,
  showAdornment: PropTypes.bool,
  disableCloseOnSelect: PropTypes.bool,
};

BarnHorsesAutocomplete.defaultProps = {
  value: null,
  validation: null,
  multiple: true,
  size: 'small',
  limitTags: 5,
  barnHorses: null,
  disabled: false,
  label: null,
  blurOnSelect: false,
  helperText: null,
  showAdornment: false,
  disableCloseOnSelect: false,
};

export default BarnHorsesAutocomplete;
